<template>
    <v-dialog
            v-model="visible"
            width="500"
            :persistent="true"
    >
        <v-card>
            <v-card-text>
                <div class="content-card-text">
                    <p>当前浏览器不满足互联网可回溯要求，请更换最新谷歌或者火狐浏览器投保，如果有问题拨打4006-234-345</p>
                    <v-divider />
                    <p><a style="text-decoration: underline; color:red;"
                          href="https://pc.qq.com/detail/1/detail_2661.html"
                          target="_blank">最新谷歌浏览器地址</a>
                    </p>
                </div>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
    export default {
        props: {
            value: {
                type: Boolean,
                default: true
            }
        },
        data(){
            return {
                v_disabled: "disabled",
                timeDown: 5,
                buttonValue: "",
                countDownInterval: "",
                buttonColor: "disabled"
            }
        },
        computed:{
            visible: {
                get() {
                    return this.value;
                },
                set(v) {
                    this.$emit("input", v);
                }
            },
        },
    }
</script>

<style lang="scss" scoped>
    .content-card-text p{
        text-align: center;
    }
    .btn-card-content{
        position: relative;
        height: 58px;
        .btn-card-content-div{
            margin: 0 auto;
            text-align: center;
        }
    }
</style>
